import { useMemo, useState } from 'react';
import { EMortgageAnnotationHeightPercent } from '../../enums/EMortgageAnnotationHeightPercent';
import { AllSpaceText } from '../AllSpaceText';
import { splitPhraseIntoTwoLines } from '../utils/splitPhraseIntoTwoLines';
import styles from './MortgageAnnotations.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MIN_LETTER_SPACING = -1.5;
export const MortgageAnnotations = _ref => {
  let {
    mortgageWarning,
    splitMortgageWarning = 'auto',
    mortgageTermsWarning,
    splitMortgageTermsWarning = 'auto',
    height
  } = _ref;
  const [splitMortgageWarningForce, setSplitMortgageWarningForce] = useState(false);
  const [splitMortgageTermsWarningForce, setSplitMortgageTermsWarningForce] = useState(false);
  const mortgageWarningView = useMemo(() => {
    if (!mortgageWarning) {
      return null;
    }
    if (splitMortgageWarning === true || splitMortgageWarning === 'force' || splitMortgageWarning === 'auto' && splitMortgageWarningForce) {
      return splitPhraseIntoTwoLines(mortgageWarning).map((text, index) => /*#__PURE__*/_jsx(AllSpaceText, {
        height: height,
        heightPercent: EMortgageAnnotationHeightPercent.Half,
        text: text
      }, index));
    }
    return /*#__PURE__*/_jsx(AllSpaceText, {
      height: height,
      heightPercent: EMortgageAnnotationHeightPercent.Default,
      text: mortgageWarning,
      onAllSpaceCalculated: _ref2 => {
        let {
          letterSpacing
        } = _ref2;
        let demount = false;
        if (splitMortgageWarning === 'auto' && letterSpacing < MIN_LETTER_SPACING) {
          setSplitMortgageWarningForce(true);
          demount = true;
        }
        return demount;
      }
    });
  }, [height, mortgageWarning, splitMortgageWarning, splitMortgageWarningForce]);
  const mortgageTermsWarningView = useMemo(() => {
    if (!mortgageTermsWarning) {
      return null;
    }
    if (splitMortgageTermsWarning === true || splitMortgageTermsWarning === 'force' || splitMortgageTermsWarning === 'auto' && splitMortgageTermsWarningForce) {
      return splitPhraseIntoTwoLines(mortgageTermsWarning).map((text, index) => /*#__PURE__*/_jsx(AllSpaceText, {
        height: height,
        heightPercent: EMortgageAnnotationHeightPercent.Half,
        text: text
      }, index));
    }
    return /*#__PURE__*/_jsx(AllSpaceText, {
      height: height,
      heightPercent: EMortgageAnnotationHeightPercent.Default,
      text: mortgageTermsWarning,
      onAllSpaceCalculated: _ref3 => {
        let {
          letterSpacing
        } = _ref3;
        let demount = false;
        if (splitMortgageTermsWarning === 'auto' && letterSpacing < MIN_LETTER_SPACING) {
          setSplitMortgageTermsWarningForce(true);
          demount = true;
        }
        return demount;
      }
    });
  }, [height, mortgageTermsWarning, splitMortgageTermsWarning, splitMortgageTermsWarningForce]);
  if (!mortgageWarningView && !mortgageTermsWarningView) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [mortgageWarningView, mortgageTermsWarningView]
  });
};